import './style.css'
import './style.css'
import { World } from './game/World'
import { bootstrap } from './core/Engine'

document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
  <canvas class="webgl"></canvas>
  <div class="overlay-interface"></div>
`
bootstrap(World)

